import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import { UpOutlined, DownOutlined } from '@ant-design/icons';
import { Card, CardHeader, Collapse } from 'reactstrap';

const columns3 = [
  {
    Header: 'Code',
    accessor: 'codeValue',
    width: 75,
  },
  {
    Header: 'Definition',
    accessor: 'codeDefinition',
    style: { 'whiteSpace': 'unset' }
  },
  {
    Header: 'Description',
    accessor: 'codeDescription',
    minWidth: 500,
    style: { 'whiteSpace': 'unset' }
  },
];

const columns2 = [
  {
    Header: 'Code',
    accessor: 'codeValue',
    width: 75,
  },
  {
    Header: 'Definition',
    accessor: 'codeDefinition',
    style: { 'whiteSpace': 'unset' }
  },
];

export default class CodeDefinitionBlock extends Component {
  static propTypes = {
    columnsLayout: PropTypes.number.isRequired,
    data: PropTypes.array.isRequired,
    cardHeader: PropTypes.string.isRequired,
    cardId: PropTypes.string.isRequired
  };

  static initialState = {
    tableIsOpen: false,
  };

  state = CodeDefinitionBlock.initialState;

  toggleTable = () => {
    this.setState(prevState => ({
      tableIsOpen: !prevState.tableIsOpen
    }))
  }

  // const[toggleQuestion, setToggequestion] = useState(1);
  render() {
    const { columnsLayout, data, cardHeader, cardId } = this.props
    const { tableIsOpen } = this.state
    return (
      <div id={cardId} className="nf-u-details__grid">
        <Card className="nf-solicitation-detail__card">
          <CardHeader
            className="nf-solicitation-detail__card-header"
            onClick={() => this.toggleTable()}
          >
            {cardHeader} {tableIsOpen ? <UpOutlined /> : <DownOutlined />}
          </CardHeader>

          <Collapse isOpen={tableIsOpen}>
            <ReactTable
              data={data}
              columns={columnsLayout === 3 ? columns3 : columns2}
              defaultPageSize={data.length > 0 ? data.length : 3}
              style={{ textAlign: 'left' }}
              showPagination={false}
            />
          </Collapse>
        </Card>
      </div>
    );
  }
};




// WEBPACK FOOTER //
// ./src/pages/static/CodeDefinitions/CodeDefinitionBlock.jsx